module.exports = __webpack_public_path__ + "static/half-template-07cce06b34eef5f031a7383216663494.jpg";